export enum ColorsEnum {
  BLUE = 'blue',
  PURPLE = 'purple',
  ORANGE = 'orange',
  PINK = 'pink',
  CYAN = 'cyan',
  RED = 'red',
  GREEN = 'green',
  GREY = 'grey',
}